(function() {
  const WORKER_URL = 'https://lively-rain-894a.noam-580.workers.dev';
  
  function initUpgradeButtons() {
    // Handle $29 upgrade button
    const btn29 = document.querySelector('.upgrade-btn-29');
    if (btn29) {
      btn29.addEventListener('click', async function() {
        await handleUpgrade(this);
      });
    }
    
    // Handle dynamic price upgrade button
    const btnDynamic = document.querySelector('.upgrade-btn-dynamic');
    if (btnDynamic) {
      btnDynamic.addEventListener('click', async function() {
        await handleUpgrade(this);
      });
    }
  }
  
  async function handleUpgrade(button) {
    const customerId = button.dataset.customerId;
    const upgradePrice = button.dataset.upgradePrice;
    const variantId = button.dataset.variantId;
    
    console.log('Upgrade clicked:', { customerId, upgradePrice, variantId });
    
    button.disabled = true;
    button.textContent = 'Creating Checkout...';
    
    try {
      const response = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: customerId,
          upgradePrice: upgradePrice,
          productVariantId: variantId
        })
      });
      
      const data = await response.json();
      console.log('Worker response:', data);
      
      if (!response.ok || !data.success) {
        throw new Error(data.error || data.details || 'Failed to create checkout');
      }
      
      // Redirect to checkout
      window.location.href = data.checkoutUrl;
      
    } catch (error) {
      console.error('Upgrade error:', error);
      alert('Error creating checkout: ' + error.message);
      button.textContent = 'Error - Try Again';
      button.disabled = false;
      setTimeout(() => {
        button.textContent = button.dataset.upgradePrice === '29' ? 'Upgrade for $29 →' : 'Upgrade for $' + parseFloat(button.dataset.upgradePrice).toFixed(2) + ' →';
      }, 3000);
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpgradeButtons);
  } else {
    initUpgradeButtons();
  }
})();